import { FC } from 'react';
import { DeliveryMethod, Maybe } from '@tools/ui/types/generated/graphql';
import {
  DeliveryMethodIcons,
  DeliveryMethodType,
  detectDeliveryMethod
} from '@tools/ui-utils/deliveryMethod.util';
import TableIcon from '../../common/icons/tableIcon.icon';

export const deliveryMethodExtraFields = [
  'deliveryMethod.verifiedStatus',
  'deliveryMethod.deliveryType'
];

type IProps = {
  deliveryMethod: Maybe<DeliveryMethod>;
  vendorHasHandle?: Maybe<boolean>;
};

const DeliveryMethodIcon: FC<React.PropsWithChildren<IProps>> = ({
  deliveryMethod,
  vendorHasHandle
}) => {
  const source = detectDeliveryMethod(deliveryMethod || ({} as DeliveryMethod));

  const { tooltip: generateTooltip, icon } =
    DeliveryMethodIcons[source] ||
    DeliveryMethodIcons[DeliveryMethodType.notVerified];

  const tooltip = generateTooltip(vendorHasHandle);

  return <TableIcon component={icon} tooltip={tooltip} />;
};

export default DeliveryMethodIcon;
